import { swallowObserverErrors, timeoutObservers, warnOnSameValueSet } from '@exodus/atoms';
import { mapValues } from '@exodus/basic-utils';
import { namespaceLogger } from '../utils.js';
const wrapAtom = ({ id, atom, logger, warnOnSameValueSetOpts, swallowObserverErrorsOpts, timeoutObserversOpts, }) => {
    let wrappedAtom = atom;
    const namespacedLogger = namespaceLogger({ logger, namespace: id });
    if (warnOnSameValueSetOpts) {
        wrappedAtom = warnOnSameValueSet({
            atom: wrappedAtom,
            logger: namespacedLogger,
            ...warnOnSameValueSetOpts,
        });
    }
    if (swallowObserverErrorsOpts) {
        wrappedAtom = swallowObserverErrors({
            atom: wrappedAtom,
            logger: namespacedLogger,
            ...swallowObserverErrorsOpts,
        });
    }
    if (timeoutObserversOpts) {
        wrappedAtom = timeoutObservers({
            atom: wrappedAtom,
            ...timeoutObserversOpts,
        });
    }
    return wrappedAtom;
};
const devModeAtoms = ({ logger, timeoutObservers: timeoutObserversOpts, warnOnSameValueSet: warnOnSameValueSetOpts, swallowObserverErrors: swallowObserverErrorsOpts, }) => {
    const preprocess = ({ definition, ...rest }) => {
        if (!['atom', 'atom-collection'].includes(String(definition.type))) {
            return { definition, ...rest };
        }
        const { factory: originalFactory, ...definitionRest } = definition;
        const factory = (opts) => {
            const wrapOpts = {
                logger,
                timeoutObserversOpts,
                warnOnSameValueSetOpts,
                swallowObserverErrorsOpts,
            };
            const result = originalFactory(opts);
            return definition.type === 'atom'
                ? wrapAtom({ id: definition.id, atom: result, ...wrapOpts })
                : mapValues(result, (atom, id) => {
                    return wrapAtom({ id: `${definition.id}.${id}`, atom, ...wrapOpts });
                });
        };
        return {
            ...rest,
            definition: {
                ...definitionRest,
                factory,
            },
        };
    };
    return { type: 'node', preprocess };
};
export default devModeAtoms;
